import all from './all';
import list from './list';
import edit from './edit';
import add from './add';

const module = {
  namespaced: true,
  modules: {
    all,
    list,
    edit,
    add,
  },
};

export default module;
